import { IAbUseExperiment } from '../../types/abUseExperiments';
import { getExperiment } from '../getExperiment';

export const getExperimentGroup = (experiments: IAbUseExperiment[], experimentName: string) => {
  const experiment = getExperiment(experiments, experimentName);

  return experiment?.groupName ?? null;
};
